var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Solid/information-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 12.0004C21.6 17.3023 17.3019 21.6004 12 21.6004C6.69806 21.6004 2.39999 17.3023 2.39999 12.0004C2.39999 6.69846 6.69806 2.40039 12 2.40039C17.3019 2.40039 21.6 6.69846 21.6 12.0004ZM13.2 7.20039C13.2 7.86313 12.6627 8.40039 12 8.40039C11.3373 8.40039 10.8 7.86313 10.8 7.20039C10.8 6.53765 11.3373 6.00039 12 6.00039C12.6627 6.00039 13.2 6.53765 13.2 7.20039ZM10.8 10.8004C10.1373 10.8004 9.59999 11.3376 9.59999 12.0004C9.59999 12.6631 10.1373 13.2004 10.8 13.2004V16.8004C10.8 17.4631 11.3373 18.0004 12 18.0004H13.2C13.8627 18.0004 14.4 17.4631 14.4 16.8004C14.4 16.1377 13.8627 15.6004 13.2 15.6004V12.0004C13.2 11.3376 12.6627 10.8004 12 10.8004H10.8Z",
    fill: "#424242"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/information-circle.9f4ad2d0ff2009fbff1c73af2a0552b0.svg";
export { ForwardRef as ReactComponent };